import React from 'react';
import { Typography, Box } from '@material-ui/core';

interface TabPanelProps {
    children?: React.ReactNode;
    show: boolean;
    index: number;
  }
  
  export default function TabPanel(props: TabPanelProps) {
    const { children, show, index, ...other } = props;
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={!!!show}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }